// src/theme.js
import { createTheme } from '@mui/material/styles';

export const getAppTheme = (makeUppercase = false) =>
  createTheme({
    mixins: {
      toolbar: {
        // This must match your *visual* top bar height
        minHeight: 96,
      },
    },
    components: {
      MuiTypography: {
        styleOverrides: {
          h1: { textTransform: makeUppercase ? 'uppercase' : 'none' },
          h2: { textTransform: makeUppercase ? 'uppercase' : 'none' },
          h3: { textTransform: makeUppercase ? 'uppercase' : 'none' },
          h4: { textTransform: makeUppercase ? 'uppercase' : 'none' },
          h5: { textTransform: makeUppercase ? 'uppercase' : 'none' },
          h6: { textTransform: makeUppercase ? 'uppercase' : 'none' },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            textTransform: makeUppercase ? 'uppercase' : 'none',
          },
        },
      },
    },
  });

// Retain the standard static theme as the default export for other files
const theme = getAppTheme(false);
export default theme;
